<template>
  <div>
    <naj-box
      :title="local.profession.title"
      :collapsed="!required"
    >
      <v-row>
        <v-col
          cols="12"
          lg="3"
        >
          <naj-input
            :type-id="formFieldType.selectbox"
            :label="local.profession.type"
            :value.sync="formModel.workTypeId"
            :value-name.sync="formModel.workTypeName"
            :items="workPlaces"
            item-text="name"
            item-value="id"
            :clearable="false"
            :validates="`${required ? 'required' : ''}`"
            :disabled="isViewMode"
            @change="workTypeChanged"
          ></naj-input>
        </v-col>
        <v-col
          v-if="formModel.workTypeId == professionTypeEnum.government"
          cols="12"
          lg="3"
        >
          <naj-input
            :type-id="formFieldType.selectbox"
            :label="local.profession.governmentAttorneys"
            :value.sync="formModel.organizationId"
            :value-name.sync="formModel.organizationName"
            :items="governmentAgencies"
            item-text="organizationName"
            item-value="id"
            :validates="`${required ? 'required' : ''}`"
            :disabled="isViewMode"
            @change="organizationChanged"
          ></naj-input>
        </v-col>
        <v-col
          v-if="this.isFirmOrCompanyOrGovernment"
          cols="12"
          lg="3"
        >
          <naj-input
            :type-id="formFieldType.text"
            :label="local.profession.profession"
            :value.sync="formModel.profession"
            :validates="`${required ? 'required' : ''}`"
            :disabled="isViewMode"
          ></naj-input>
        </v-col>
        <v-col
          v-if="this.isFirmOrCompanyOrGovernment"
          cols="12"
          lg="3"
        >
          <naj-input
            :type-id="formFieldType.text"
            :label="local.profession.workingPlaceName"
            :value.sync="formModel.workingPlaceName"
            :validates="`${required ? 'required' : ''}`"
            :disabled="isViewMode"
          ></naj-input>
        </v-col>

        <v-col
          v-if="this.showAuthorityFields"
          cols="12"
          lg="3"
        >
          <naj-input
            :type-id="formFieldType.selectbox"
            :label="local.profession.diplomaticAuthority"
            :value.sync="formModel.centralAuthorityId"
            :value-name.sync="formModel.centralAuthorityName"
            :items="authorityItems"
            item-text="name"
            item-value="id"
            :validates="`${required ? 'required' : ''}`"
            :disabled="isViewMode"
            @change="diplomaticAuthorityChanged"
          ></naj-input>
        </v-col>

        <v-col
          v-if="this.showAuthorityFields"
          cols="12"
          lg="3"
        >
          <naj-input
            :type-id="formFieldType.selectbox"
            :label="local.profession.subAuthority"
            :value.sync="formModel.subAuthorityId"
            :value-name.sync="formModel.subAuthorityName"
            :items="subAuthorities[formModel.centralAuthorityId]"
            item-value="id"
            item-text="name"
            :validates="`${required ? 'required' : ''}`"
            :disabled="!(subAuthorities[formModel.centralAuthorityId] || []).length || !formModel.centralAuthorityId || isViewMode"
          ></naj-input>
        </v-col>
      </v-row>
    </naj-box>

    <!-- <naj-address
      v-if="isFirmOrCompanyOrGovernment"
      :title="local.titleHeader.workAddress"
      :form-model="formModel.workAddress"
      required
    ></naj-address> -->
  </div>
</template>

<script>
import { professionTypeEnum, governmentalOrganizations, professionTypeNameEnum } from '@/helpers/enum';
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapLUTState, mapActions: mapLUTActions } = createNamespacedHelpers(
  'LookupsModule'
);

export default {
  inject: ['$validator'],
  props: ['formModel', 'required', 'isViewMode'],
  data() {
    return {
      professionTypeEnum,
      governmentalOrganizations,
      professionTypeNameEnum,
    };
  },
  created() {
    this.getWorkPlaces();
    this.getGovernmentAgencies();
    this.getDiplomaticAuthorities();

    if (this.formModel.organizationId == governmentalOrganizations.MinistryOfInteriors.id
      || this.formModel.organizationId == governmentalOrganizations.MinistryOfDefence.id) {
      this.getCentralAuthoritiesForMinistries(this.formModel.organizationId);
    }
    if (this.formModel.centralAuthorityId) {
      this.getSubAuthoritiesByCentralAuthorityId(this.formModel.centralAuthorityId);
    }
  },
  computed: {
    ...mapLUTState(['workPlaces', 'governmentAgencies', 'diplomaticAuthorities', 'subAuthorities', 'centralAuthoritiesForMinistries']),
    isFirmOrCompanyOrGovernment() {
      if (!this.formModel.workTypeId) {
        this.$set(this.formModel, 'workTypeId', professionTypeEnum.unEmployed);
        this.$set(this.formModel, 'workTypeName', professionTypeNameEnum[professionTypeEnum.unEmployed]);
      }
      return (
        // eslint-disable-next-line eqeqeq
        this.formModel.workTypeId == professionTypeEnum.firm ||
        // eslint-disable-next-line eqeqeq
        this.formModel.workTypeId == professionTypeEnum.company ||
        // eslint-disable-next-line eqeqeq
        this.formModel.workTypeId == professionTypeEnum.government
      );
    },
    showAuthorityFields() {
      return this.formModel.workTypeId == professionTypeEnum.diplomaticAuthority
        || this.formModel.organizationId == governmentalOrganizations.MinistryOfInteriors.id
        || this.formModel.organizationId == governmentalOrganizations.MinistryOfDefence.id;
    },
    authorityItems() {
      if (this.formModel.workTypeId == professionTypeEnum.diplomaticAuthority) {
        return this.diplomaticAuthorities;
      } else if (this.formModel.organizationId == governmentalOrganizations.MinistryOfInteriors.id
        || this.formModel.organizationId == governmentalOrganizations.MinistryOfDefence.id) {
        return this.centralAuthoritiesForMinistries[this.formModel.organizationId];
      }
      return [];
    },
  },
  methods: {
    ...mapLUTActions(['getWorkPlaces', 'getGovernmentAgencies', 'getDiplomaticAuthorities', 'getSubAuthoritiesByCentralAuthorityId', 'getCentralAuthoritiesForMinistries']),
    workTypeChanged() {
      this.$set(this.formModel, 'profession', null);
      this.$set(this.formModel, 'workingPlaceName', null);
      this.$set(this.formModel, 'organizationId', null);

      this.$set(this.formModel, 'centralAuthorityId', null);
      this.$set(this.formModel, 'subAuthorityId', null);
      this.$set(this.formModel, 'subAuthority', null);
    },
    diplomaticAuthorityChanged(value) {
      if (value) {
        this.getSubAuthoritiesByCentralAuthorityId(value);
        this.$set(this.formModel, 'subAuthorityId', null);
        this.$set(this.formModel, 'subAuthority', null);
      }
    },
    organizationChanged(value) {
      if (value && (value == governmentalOrganizations.MinistryOfInteriors.id
        || value == governmentalOrganizations.MinistryOfDefence.id)) {
        this.getCentralAuthoritiesForMinistries(value);
        this.$set(this.formModel, 'centralAuthorityId', null);
        this.$set(this.formModel, 'subAuthorityId', null);
        this.$set(this.formModel, 'subAuthority', null);
      }
    },
  },
};
</script>
